import { RECAPTCHA_CONFIG } from '../config/constants';

function loadRecaptchaV3Script() {
  if (window.grecaptcha) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-tivigo-recaptcha-v3]')) {
      const start = Date.now();
      const iv = setInterval(() => {
        if (window.grecaptcha) {
          clearInterval(iv);
          resolve();
        } else if (Date.now() - start > 15000) {
          clearInterval(iv);
          reject(new Error('timeout'));
        }
      }, 50);
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_CONFIG.V3_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.dataset.tivigoRecaptchaV3 = '1';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('script'));
    document.head.appendChild(script);
  });
}

/** Arka plan login / token yenileme için v3 token (endpoint zorunlu tutuyor). */
export async function getRecaptchaLoginToken() {
  try {
    await loadRecaptchaV3Script();
  } catch {
    return '';
  }
  if (!window.grecaptcha) {
    return '';
  }
  try {
    return await new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(RECAPTCHA_CONFIG.V3_SITE_KEY, { action: 'login' })
          .then(resolve)
          .catch(reject);
      });
    });
  } catch {
    return '';
  }
}
